import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'

// 单纯的是为了带有token信息的去跳转
export default function TokenLogin() {
  const history = useHistory()
  const { pathname, search } = useLocation()
  const { token } = queryString.parse(search)
  if (token) {
    localStorage.setItem('token', token)
    history.push(pathname)
  }
  return <div></div>
}